__turbopack_context__.v({
  "className": "noto_sans_oriya_fee93d4d-module__l3cMMq__className",
});
